import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-transformers',
  templateUrl: './power-transformers.component.html',
  styleUrls: ['./power-transformers.component.css']
})
export class PowerTransformersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	
  }

}
